import type { TableFilterField } from '@shared/ui';

export const companyVacanciesFiltersConfig: TableFilterField[] = [
  {
    name: 'id',
    label: 'ID',
    type: 'number' as const,
    placeholder: 'Все',
  },
  {
    name: 'vacancy',
    label: 'Вакансия',
    type: 'text' as const,
    placeholder: 'Все',
  },
  {
    name: 'createdAt',
    label: 'Дата создания',
    type: 'date-range' as const,
  },
  {
    name: 'recruter',
    label: 'Рекрутер',
    type: 'text' as const,
    placeholder: 'Все',
    apiKey: 'user.name',
  },
  {
    name: 'city',
    label: 'Город',
    type: 'select-city' as const,
    apiKey: 'cities.name',
    placeholder: 'Все',
  },
  {
    name: 'salary',
    label: 'Уровень дохода',
    type: 'text' as const,
    placeholder: 'Все',
  },
  {
    name: 'status',
    label: 'Статус',
    type: 'select' as const,
    options: [
      { value: 'active', label: 'Активна' },
      { value: 'inactive', label: 'Неактивна' },
    ],
    clearable: true,
  },
];

export const initialValues = {
  id: '',
  vacancy: '',
  createdAt: [null, null],
  recruter: '',
  city: [],
  salary: '',
  status: null,
};
